<template>
    <div class="journal-item card-box bg-box" :style="[{'border-top': '5px solid ' + tag.color}]">
        <div class="journal-item-information">
            <div class="row">
                <div class="col-xs-12">
                    <h5 class="float-left">{{ tag.name }}</h5>
                </div>
            </div>
        </div>
        <div :id="'journal-tag-content-' + tag.id" class="journal-item-content" v-sanitize-html="fixed_tag_content"></div>
    </div>
</template>

<script type="text/javascript">

export default {
    props: {
        journalTag: {
            required: true,
        }
    },

    data() {
        return {
            tag: this.journalTag,
        }
    },

    computed: {
        fixed_tag_content() {
            let tagContent = ''

            this.tag.content.forEach(element => {
                tagContent += '<div class="journal-tag-content-item" style="border-left:5px solid #ddd;padding-left: 10px;margin:10px 0;">' + element + '</div>'
            });

            // replace all single spaces with an actual space, so it can break to new lines
            let reg = new RegExp('\\w(&nbsp;)\\w', 'gi');
            html = tagContent.replace(reg, (match, group) => match.replace(group, ' '));

            let el = $('<div></div>').html(this.sanitizeHtml(html));
            el.find('table:not(.table)').removeAttr('align').addClass('table').wrap('<div class="table-responsive"></div>');
            el.append($('<div class="clear-both"></div>'));

            return el.html();
        },
    }
}

</script>
